import { timeInMs } from '../../../../shared';
import cachedFetch from '../../../../shared/cachedFetch';
import { Video } from './types';

export const getResolutionUrl = (
  screenWidth: number,
  resolutions: number[][],
  url: string
): string => {
  if (typeof window !== 'undefined') {
    const [thumbnail, ...res] = resolutions;
    const [basename, ext] = url.split('.');
    const screen =
      screenWidth !== thumbnail[0] && screenWidth * window.devicePixelRatio;

    const [width, height] =
      screenWidth === thumbnail[0]
        ? thumbnail
        : res.reduce((prev, curr) =>
            Math.abs(curr[0] - screen) < Math.abs(prev[0] - screen)
              ? curr
              : prev
          );

    return `https://assets.oceanhero.today/backgrounds/${encodeURIComponent(
      basename
    )}-${width}x${height}.${ext}`;
  }
};

export const preloadPicture = (
  src: string,
  alt = ''
): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.alt = alt;
    img.onload = (): void => resolve(img);
    img.onerror = (): void => reject();
  });

export const capitalize = (str: string): string =>
  str
    ?.toLocaleLowerCase()
    ?.replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase());

export const checkImageResolution = async (
  pictureUrl: string,
  screenWidth: number
): Promise<boolean> => {
  return await new Promise((resolve, reject) => {
    const img = new Image();
    img.src = pictureUrl;
    // eslint-disable-next-line
    img.onload = (event: any): void => {
      resolve(event.path?.[0]?.width < screenWidth);
    };
    img.onerror = (): void => reject();
  });
};

export const preloadVideo = (src: string): Promise<HTMLVideoElement> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.src = src;

    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

    if (isFirefox) {
      video.oncanplay = (): void => resolve(video);
    } else {
      video.oncanplaythrough = (): void => resolve(video);
      video.remove();
    }

    video.onerror = (): void => reject();
  });
};

export const getRandomVideo = async (
  currentIndex = 0
): Promise<{
  newIndex: number;
  url: string;
  subtitle: string;
  title: string;
  creditUrl: string;
  id: number;
}> => {
  const videos = (await cachedFetch(
    'https://assets.oceanhero.today/backgrounds/videos.json',
    timeInMs.day
  ).catch((err) => {
    console.error('fetchVideos', err);
    return null;
  })) as Video[];

  if (!videos) return null;

  const video = videos[currentIndex + 1] || videos[0];

  const endpoint =
    'https://assets.oceanhero.today/backgrounds/videos/' + video.url;

  await preloadVideo(endpoint);

  return {
    newIndex: currentIndex + 1 >= videos.length ? 0 : currentIndex + 1,
    url: endpoint,
    title: 'Video by ' + video.user.name,
    subtitle: 'From Pexels',
    creditUrl: video.pexelsUrl,
    id: video.id,
  };
};
